import { ThemeProvider } from "styled-components";
import { Layout } from "./common/Styles";
import About from "./components/About";
import Header from "./components/Header";
import ComingSoon from "./common/ComingSoon";
import Skills from "./components/Skills";
import Projects, { Project, ProjectImageOrientation } from "./common/Projects";

const theme = {
  colors: {
    light: "#F6F8FF",
    blue: "#4a7fe5",
    ligthBlue: "#A8B5EC",
    gradient:
      "linear-gradient(to right top, #4a7fe5, #7d9ced, #a7baf3, #cfd9fa, #f6f8ff)",
  },
};

// Using gradient placeholders for each project with unique colors
const createGradientImage = (colors: string[]) => {
  return `data:image/svg+xml,${encodeURIComponent(`
    <svg width="600" height="300" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color:${colors[0]};stop-opacity:1" />
          <stop offset="100%" style="stop-color:${colors[1]};stop-opacity:1" />
        </linearGradient>
      </defs>
      <rect width="600" height="300" fill="url(#grad)"/>
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="32" fill="white" text-anchor="middle" dominant-baseline="middle" opacity="0.3">${colors[2]}</text>
    </svg>
  `)}`;
};

const projects: Project[] = [
  {
    title: "TableFlow",
    description: "QR Menu & Ordering System - Digitize your menu, accept payments, and manage tables all from one app. Features QR-based digital menus, online payments, visual table layout, and real-time order management.",
    image: createGradientImage(["#3B82F6", "#2563EB", "TableFlow"]),
    imageOrientation: "landscape" as ProjectImageOrientation,
    techs: [
      { name: "Next.js", icon: "SiNextdotjs", color: "#000000" },
      { name: "React", icon: "SiReact", color: "#61DAFB" },
      { name: "TypeScript", icon: "SiTypescript", color: "#3178C6" },
      { name: "Tailwind CSS", icon: "SiTailwindcss", color: "#38BDF8" },
    ],
  },
  {
    title: "SalonFlow",
    description: "Booking & Management System - Manage appointments, clients, schedules, and services in one clean dashboard. Features online booking, staff schedules, appointment reminders, and client history tracking.",
    image: createGradientImage(["#9333EA", "#7C3AED", "SalonFlow"]),
    imageOrientation: "landscape" as ProjectImageOrientation,
    techs: [
      { name: "Next.js", icon: "SiNextdotjs", color: "#000000" },
      { name: "React", icon: "SiReact", color: "#61DAFB" },
      { name: "TypeScript", icon: "SiTypescript", color: "#3178C6" },
      { name: "Supabase", icon: "SiSupabase", color: "#3490DC" },
      { name: "Tailwind CSS", icon: "SiTailwindcss", color: "#38BDF8" },
    ],
  },
  {
    title: "VoiceFlow",
    description: "AI Voice Assistant - AI-powered voice assistant that works from phone calls. Features phone call integration, natural voice conversations, and AI-powered assistance. Ready to integrate with TableFlow and SalonFlow.",
    image: createGradientImage(["#10B981", "#059669", "VoiceFlow"]),
    imageOrientation: "landscape" as ProjectImageOrientation,
    techs: [
      { name: "Next.js", icon: "SiNextdotjs", color: "#000000" },
      { name: "React", icon: "SiReact", color: "#61DAFB" },
      { name: "TypeScript", icon: "SiTypescript", color: "#3178C6" },
      { name: "OpenAI", icon: "SiOpenai", color: "#412991" },
    ],
  },
  {
    title: "QR Generator",
    description: "Branded QR Codes - Generate custom branded QR codes with your logo and colors. Simple and effective solution featuring custom branding, logo integration, color customization, and high-quality output.",
    image: createGradientImage(["#F97316", "#EA580C", "QR Generator"]),
    imageOrientation: "landscape" as ProjectImageOrientation,
    techs: [
      { name: "Next.js", icon: "SiNextdotjs", color: "#000000" },
      { name: "React", icon: "SiReact", color: "#61DAFB" },
      { name: "TypeScript", icon: "SiTypescript", color: "#3178C6" },
      { name: "Tailwind CSS", icon: "SiTailwindcss", color: "#38BDF8" },
    ],
  },
  {
    title: "CustomFlow",
    description: "Custom Software & Apps - Build custom software solutions and mobile apps tailored to unique business needs. Features custom development, web & mobile apps, API integration, and full-stack solutions.",
    image: createGradientImage(["#6366F1", "#4F46E5", "CustomFlow"]),
    imageOrientation: "landscape" as ProjectImageOrientation,
    techs: [
      { name: "Next.js", icon: "SiNextdotjs", color: "#000000" },
      { name: "React", icon: "SiReact", color: "#61DAFB" },
      { name: "TypeScript", icon: "SiTypescript", color: "#3178C6" },
      { name: "Node.js", icon: "SiNodedotjs", color: "#339933" },
    ],
  },
];

const App = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <Header />
      <About />
      <div style={{ marginTop: "5rem" }}>
        <Skills />
      </div>
      <div style={{ marginTop: "5rem" }}>
        <Projects projects={projects} />
      </div>
      <ComingSoon />
    </Layout>
  </ThemeProvider>
);

export default App;
